import React from 'react';
import {message, useIntl} from '@sail/intl';
import {media, tokens, view} from '@sail/ui';

import {useSelector} from 'src/return/state/store';
import {useReturnDetailsCollectionContext} from 'src/return/state/useReturnDetailsCollectionContext';
import {Link, MerchantLogo, Text} from 'src/v2/components/common';

const messages = {
  needHelp: message({
    id: 'crypto.payins.return.header.need_help',
    description: 'Link to the Stripe support page',
    defaultMessage: 'Need help?',
  }),
};

export const Header = (): React.ReactElement => {
  const intl = useIntl();
  const logo = useSelector((state) => state.merchantBranding.logo);
  const merchantName = useSelector(
    (state) => state.merchantBranding.merchantName,
  );
  const {sessionId} = useReturnDetailsCollectionContext();
  // Support currently routes non-crypto_payin_session params to Financial Accounts.
  // Reuse this param for return sessions until Support accepts a dedicated param.
  const contactSupportUrl = `https://support.stripe.com/user/contact/email?crypto_payin_session=${sessionId}`;

  return (
    <view.div
      css={{
        stack: 'x',
        height: 'space.900',
        distribute: 'space-between',
        alignY: 'center',
        paddingX: 'space.500',
        paddingY: 'space.0',
        [media.down(tokens.viewport.medium)]: {
          height: '48px',
          paddingX: '16px',
        },
      }}
      data-testid="return-header"
    >
      <view.div
        css={{
          stack: 'x',
          gap: 'small',
          alignY: 'center',
          width: 'fit',
        }}
      >
        <MerchantLogo
          logoUrl={logo}
          businessName={merchantName}
          style={{maxHeight: '32px', width: 'auto'}}
        />
      </view.div>

      <Link type="secondary" href={contactSupportUrl} target="_blank">
        <Text type="body" css={{color: 'subdued'}}>
          {intl.formatMessage(messages.needHelp)}
        </Text>
      </Link>
    </view.div>
  );
};
